@use '~/theme/theme' as *;

.container {
  display: flex;
  align-items: center;
  margin-top: spacing(2);
  margin-bottom: spacing(2);
  flex: 1;

  @include border-radius(sm);

  overflow: hidden;
}

.collapsedTab {
  flex-shrink: 0;
}

.navigationTabBar {
  flex-shrink: 0;
}

.hidden {
  position: absolute;
  visibility: hidden;
}
